var _style, _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 27",
    style: {
      enableBackground: "new 0 0 28 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#231F20;}\r\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{mask:url(#mask-2_1_);}\r\n\t.st4{fill:#056CBA;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "segment header/inactive/white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IS-Portal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "P-Certificates-05-TY-Update-V2",
    transform: "translate(-390.000000, -260.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(102.000000, 68.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(288.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "segment-header_x2F_inactive_x2F_white-list-noarrow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_x2F_navigation_x2F_chevron_x2F_right",
    transform: "translate(16.326531, 25.000000) scale(-1, 1) translate(-16.326531, -25.000000) translate(0.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.750000, 2.666667)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1_1_",
    className: "st0",
    d: "M9.8,27c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L20.7,14L9.1,2.7 c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1.1-0.4,1.5,0l12.4,12c0.4,0.4,0.4,1,0,1.4l-12.4,12C10.3,26.9,10.1,27,9.8,27"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_2_",
    className: "st2",
    d: "M9.8,27c-0.3,0-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4L20.7,14L9.1,2.7 c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1.1-0.4,1.5,0l12.4,12c0.4,0.4,0.4,1,0,1.4l-12.4,12C10.3,26.9,10.1,27,9.8,27"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "color_x2F__x23_056CBA",
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_x23_1C93F1",
    className: "st4",
    points: "1.9,0.3 29.9,0.3 29.9,27.3 1.9,27.3  "
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftBlue);
export default __webpack_public_path__ + "static/media/arrow-left-blue.0b3b18e4c9582608a670e88948d7ac9d.svg";
export { ForwardRef as ReactComponent };